import React from "react";
import { Link, NavLink } from "react-router-dom";
import "../SuccessfullCompleted/successfullCompleted.css";

const SuccessfullCompleted = ({ homework_id, clickedHeader }) => {
  const helper = () => {
    if (clickedHeader === "review") {
      return `/onreviewstudentlistHW`
    } else if (clickedHeader === "completed") {
      return `/CompleteStudentListHW`
    }
  }
  return (
    <div className=" successful_preview_transprant_body_hw ">
      <div className=" p-2 successful_preview_container shadow">
        <img src="images/Ellipse 208.svg" alt="" />
        <span className=" my-4 successfully_message">
          Successfully Completed student homework
        </span>

        <NavLink state={{ homework_id: homework_id }} to={helper()} >
          <button className="successfull_okay_btn" >Okay</button>
        </NavLink>
      </div>
    </div>
  );
};

export default SuccessfullCompleted;
